const itemFactory = ({ title, code, type, discount, rebatePrice, startDate, endDate } = {}) => {
  return {
    "title": title || "7月優惠",
    "code": code || "iPet0701",
    "type": type || "fixed",
    "discount": discount || 100,
    "rebatePrice": rebatePrice || 1,
    "startDate": startDate || "2020-12-01",
    "endDate": endDate || "2020-12-05"
  }
};

export const COUPON_LIST = [
  itemFactory({
    "title": "7月優惠",
    "code": "iPet0701",
    "type": "fixed",
    "discount": 100,
    "rebatePrice": 1,
    "startDate": "2020-12-01",
    "endDate": "2020-12-05"
  }),
  itemFactory({
    "title": "夏日專屬優惠",
    "code": "SummerSale",
    "type": "%",
    "discount": 15,
    "rebatePrice": 1,
    "startDate": "2020-12-01",
    "endDate": "2020-12-05"
  }),
  itemFactory({
    "title": "8月優惠",
    "code": "iPet0801",
    "type": "fixed",
    "discount": 100,
    "rebatePrice": 1,
    "startDate": "2020-12-01",
    "endDate": "2020-12-05"
  }),
  itemFactory({
    "title": "9月優惠",
    "code": "iPet001",
    "type": "fixed",
    "discount": 100,
    "rebatePrice": 1,
    "startDate": "2020-12-01",
    "endDate": "2020-12-05"
  }),
  itemFactory({
    "title": "大大大優惠",
    "code": "BattleCats",
    "type": "%",
    "discount": 100,
    "rebatePrice": 1,
    "startDate": "2020-12-01",
    "endDate": "2020-12-05"
  })
];

export const COUPON_ITEM = itemFactory();
